<template>
  <div class="login-container">
    <div class="login-card">
      <div class="back-button">
        <router-link to="/" class="back-link">
          <i class="fas fa-arrow-left"></i> Back to Home
        </router-link>
      </div>
      <h2>Login to Riddhi</h2>
      <form @submit.prevent="handleLogin" class="login-form">
        <div class="form-group">
          <label for="username">Email or Username</label>
          <input
            type="text"
            id="username"
            v-model="username"
            required
            placeholder="Enter your email or username"
          />
        </div>
        <div class="form-group">
          <label for="password">Password</label>
          <input
            type="password"
            id="password"
            v-model="password"
            required
            placeholder="Enter your password"
          />
        </div>
        <button type="submit" class="login-button" :disabled="loading">
          {{ loading ? "Logging in..." : "Login" }}
        </button>
        <p v-if="error" class="error-message">{{ error }}</p>
      </form>
      <div class="login-footer">
        <a href="#" @click.prevent="forgotPassword">Forgot Password?</a>
      </div>
    </div>
  </div>
</template>

<script>
// import {
//   signIn,
//   getCurrentUser,
//   fetchUserAttributes,
//   signOut,
//   fetchAuthSession,
// } from "@aws-amplify/auth";
// import { getCurrentUser, fetchUserAttributes } from "@aws-amplify/auth";
import { mapActions } from "vuex";
// import { Auth } from "aws-amplify";
// import { FederatedSignIn } from "@aws-amplify/ui-vue";
// import { signInWithRedirect } from "@aws-amplify/auth";

export default {
  name: "LoginView",
  data() {
    return {
      username: "",
      password: "",
      error: "",
      loading: false,
    };
  },
  methods: {
    ...mapActions(["login"]),
    async handleLogin() {
      this.loading = true;
      this.error = "";

      try {
        // Get these values from your aws-config.js
        // const clientId = "5l9beaq1niaeg70jag9sd6u29a";
        // const domain =
        //   "riddhi-dev-ap-south-1-349100327741.auth.ap-south-1.amazoncognito.com";

        const clientId = "2g84dlu4d6uqsigg1pvfcojnuj";
        const domain =
          "riddhi-preprod-ap-south-1-349100327741.auth.ap-south-1.amazoncognito.com";

        const redirectUri = encodeURIComponent(window.location.origin);
        console.debug("Redirect URI:", redirectUri);
        const scopes = encodeURIComponent(
          "phone openid profile email api.crm.riddhi.co.in/admin api.crm.riddhi.co.in/read api.crm.riddhi.co.in/write aws.cognito.signin.user.admin email openid phone profile"
        );

        // Construct the Cognito hosted UI URL
        const authorizeUrl = `https://${domain}/oauth2/authorize?client_id=${clientId}&response_type=code&scope=${scopes}&redirect_uri=${redirectUri}`;

        console.log("Redirecting to Cognito Hosted UI:", authorizeUrl);

        // Redirect to Cognito Hosted UI
        window.location.href = authorizeUrl;
      } catch (error) {
        console.error("Error redirecting to login:", error);
        this.error = error.message || "An error occurred during login";
        this.loading = false;
      }
      // this.loading = true;
      // this.error = "";

      // try {
      //   await signOut();
      //   console.log("signOut called");
      //   const { isSignedIn } = await signIn({
      //     username: this.username,
      //     password: this.password,
      //   });

      //   if (isSignedIn) {
      //     const user = await getCurrentUser();
      //     const attributes = await fetchUserAttributes();
      //     const session = await fetchAuthSession();
      //     const accessToken = session.tokens.accessToken.toString();
      //     const groups =
      //       session.tokens.accessToken["payload"]["cognito:groups"] || [];
      //     console.log("Groups", groups);
      //     const isAdmin = groups.includes("Admin");
      //     console.log("isAdmin", isAdmin);
      //     console.info("user:", user);

      //     console.log(
      //       "Type",
      //       session.tokens.accessToken["payload"]["cognito:groups"]
      //     );

      //     // Store token and user info in Vuex
      //     await this.login({
      //       token: accessToken,
      //       user: {
      //         id: attributes.sub,
      //         email: attributes.email,
      //         name: attributes.name || user.username,
      //         isAdmin: isAdmin,
      //       },
      //     });
      //     // Determine redirect based on user role
      //     let redirect;
      //     if (isAdmin) {
      //       redirect = this.$route.query.redirect || "/admin";
      //     } else {
      //       redirect = this.$route.query.redirect || "/dashboard";
      //     }
      //     console.log("redirect:", redirect);
      //     this.$router.push(redirect);
      //   }
      // } catch (error) {
      //   console.error("Error during login:", error);
      //   this.error = error.message || "An error occurred during login";
      // } finally {
      //   this.loading = false;
      // }
    },
    // async forgotPassword() {
    //   if (!this.username) {
    //     this.error = "Please enter your email or username";
    //     return;
    //   }

    //   try {
    //     await Auth.forgotPassword(this.username);
    //     this.$router.push({
    //       name: "ResetPassword",
    //       params: { username: this.username },
    //     });
    //   } catch (error) {
    //     this.error = error.message || "Error initiating password reset";
    //   }
    // },
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
  padding: 2rem;
  background-color: #f8f9fa;
}

.login-card {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  position: relative;
}

.login-card h2 {
  color: #072ac8;
  text-align: center;
  margin-bottom: 2rem;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  color: #2c3e50;
  font-weight: 500;
}

.form-group input {
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.login-button {
  background-color: #072ac8;
  color: white;
  padding: 0.75rem;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
}

.login-button:hover:not(:disabled) {
  background-color: #051a75;
}

.login-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.error-message {
  color: #dc3545;
  text-align: center;
  margin-top: 1rem;
}

.login-footer {
  margin-top: 1.5rem;
  text-align: center;
}

.login-footer a {
  color: #072ac8;
  text-decoration: none;
}

.login-footer a:hover {
  text-decoration: underline;
}

.back-button {
  position: absolute;
  top: 1.5rem;
  left: 1.5rem;
}

.back-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #072ac8;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s;
}

.back-link:hover {
  color: #051a75;
}

.back-link i {
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .back-button {
    top: 1rem;
    left: 1rem;
  }
}
</style>
